import React, { useState, useEffect, useCallback } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { useIdleTimer } from "react-idle-timer";
import { CircularProgress } from "@mui/material";


// Core
import { useAuth } from "./contexts/AuthContext";
import ScrollToTop from "./components/ScrollToTop";
import Navbar from "./components/navbar/Navbar";
// import RequestAccess from "./pages/RequestAccess";
import UserSecurity from "./components/UserSecurity/index.jsx";

// Dashboard / Common
import DashboardRedesign from "./pages/dashboard/DashboardRedesign";
import LoginPage from "./pages/Login";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Profile from "./pages/user/ProfilePage.jsx";
import NotificationList from "./pages/Notification/index.jsx";

// Approver Dashboard
// import ApproverDashboard from "./pages/approver/proposals/ProposalApprovalPage.jsx";
import ProposalsApprovalPage from "./pages/approver/proposals/ProposalApprovalPage.jsx";

/* --------------------------------------------------------------------------
   SETUP MODULE
-------------------------------------------------------------------------- */
import Customer from "./pages/setup/components/Customer/customer.jsx";
import Employee from "./pages/setup/components/Employee/employee.jsx";
import EmployeeList from "./pages/setup/components/Employee/components/EmployeeTable/EmployeeList.jsx";
import BuildingList from "./pages/setup/components/Building/buildinglist.jsx";
import Building from "./pages/setup/components/Building/building.jsx";
import BuildingForm from "./pages/setup/components/Building/components/Forms/buildingform.jsx";
import ViewBuildingLedger from "./pages/setup/components/Building/Actions/View Building Ledger/ViewBuildingLedger.jsx";
import AccountCollections from "./pages/setup/components/Building/Account Collections/AccountCollections.jsx";
import BuildingRecords from "./pages/setup/components/Building/Actions/View Building Records/ViewBuildingRecords.jsx";
import DevicePage from "./pages/setup/components/Device List/DevicePage.jsx";
import DeviceEntry from "./pages/setup/components/Device List/Device Entry/DeviceEntryForm.jsx";
import DeviceView from "./pages/setup/components/Device List/ViewDevice.jsx";
import AddDevice from "./pages/setup/components/Building/Actions/Add a Device/AddDevice.jsx";
import ProposalWizard from "./pages/proposals/components/ProposalWizard/components/proposalWizard.jsx";
import AddMaintenanceContractWizard from "./pages/maintenance/components/MaintenanceContractWizard/AddMaintenanceContractWizard.jsx";
import ViewBuilding from "./pages/setup/components/Building/components/Modals/ViewBuildingModal.jsx";
import ActionItemsEntry from "./pages/callcenter/components/ActionItems/actionItemsEntry.jsx";
import Rolodex from "./pages/setup/components/Rolodex/Rolodex.jsx";
import ManagementCompanies from "./pages/setup/components/managementcompanies/managementcompanies";
import Dataonboarding from "./pages/setup/components/Onboarding/dataonboarding";
import SalesPerson from "./pages/setup/components/SalesPerson/SalesPerson";
import TaxDetails from "./pages/setup/components/TaxDetails/TaxDetails";
import PaymentTerms from "./pages/setup/components/PaymentTerms/PaymentTerms";
import CompanyDefaultsPage from "./pages/setup/components/Company Defaults/CompanyDefaultsPage.jsx";
import Inspectors from "./pages/setup/components/Inspectors/Inspectors.jsx";
import BuildingDeviceEditing from "./pages/setup/components/Building/Actions/Open Device Type Editing/BuildingDeviceEditing.jsx";

/* --------------------------------------------------------------------------
   CALL CENTER MODULE
-------------------------------------------------------------------------- */
import TroubleCallEntry from "./pages/callcenter/components/TroubleCall/troublecallentry.jsx";
import EditTroubleCallForm from "./pages/callcenter/components/TroubleCall/edittroublecallform.jsx";
import TimeTicketEntryAndEdit from "./pages/callcenter/components/TimeTicketEntry/TimeTicketEntryPage.jsx";
import TimeTicketForm from "./pages/callcenter/components/TimeTicketEntry/timeticketform.jsx";
import CallCenterList from "./pages/callcenter/components/CallCenterList/CallCenterListPage.jsx";
import EditCallCenterForm from "./pages/callcenter/components/CallCenterList/editcallcenterform.jsx";
import History from "./pages/callcenter/components/History/HistoryPage.jsx";
import HistoryEdit from "./pages/callcenter/components/History/HistoryEdit.jsx";
import DispatchEntry from "./pages/callcenter/components/DispatchEntry/dispatchEntry.jsx";
import EmployeeLog from "./pages/callcenter/components/EmployeeLog/EmployeeLogPage.jsx";
import SurveyRequestEntry from "./pages/callcenter/components/SurveyRequestEntry/SurveyRequestEntryPage.jsx";
import DispatchHours from "./pages/callcenter/components/DispatchHours/DispatchHoursPage.jsx";
import AdvancedCallCenterDashboard from "./pages/callcenter/components/CallCenter/AdvancedCallCenterDashboard.jsx";

/* --------------------------------------------------------------------------
   MAINTENANCE MODULE
-------------------------------------------------------------------------- */
import MaintenanceDashboard from "./pages/maintenance/components/MaintenanceDashboard/MaintenanceDashboardPage.jsx";
import MaintenanceScheduled from "./pages/maintenance/components/Maintenance Schedule/ScheduledMaintenancePage.jsx";
import ParentContractSetup from "./pages/maintenance/components/Parent Contract Setup/ParentContractSetupPage.jsx";
import MaintenanceContractsList from "./pages/maintenance/components/Maintenance Contract List/MaintenanceContractListPage.jsx";
import InvoicingEmailSetup from "./pages/maintenance/components/InvoicingEmailSetup/InvoicingEmailSetupPage.jsx";
import MaintenanceRoutePlanning from "./pages/maintenance/components/MaintenanceRoutePlanning/maintenanceRoutePlanning.jsx";
import RouteAnalysis from "./pages/maintenance/components/RouteAnalysis/RouteAnalysisPage.jsx";
import RouteSummary from "./pages/maintenance/components/RouteSummary/RouteSummaryPage.jsx";

/* --------------------------------------------------------------------------
   INSPECTIONS & VIOLATIONS MODULE
-------------------------------------------------------------------------- */
import ViolationsList from "./pages/inspections/components/ViolationsList/ViolationsListPage.jsx";
import Agency from "./pages/inspections/components/AgencyList/Agency.jsx";
import DOBNowConnect from "./pages/inspections/components/DOBNowConnect/DOBNowConnect.jsx";
import DeviceDataDefects from "./pages/inspections/components/DOBNowConnect/DeviceDataDefects.jsx";
import GroupNumberDevices from "./pages/inspections/components/DOBNowConnect/GroupNumberDevices.jsx";
import ViolationTracking from "./pages/inspections/components/ViolationTracking/ViolationsTrackingPage.jsx";
import ViolationsEntry from "./pages/inspections/components/ViolationsEntry/ViolationsEntryPage.jsx";
import DeviceTests from "./pages/inspections/components/DeviceTests/DeviceTestsPage.jsx";
import ServiceCompanies from "./pages/inspections/components/ServiceCompanies/ServiceCompanyListPage.jsx";
import InspectionsList from "./pages/inspections/components/InspectionList/inspectionslistPage.jsx";
import InspectionsEntry from "./pages/inspections/components/TestsInspectionsEntry/BuildingInspectionsEntryPage.jsx";
import InspectionsWizard from "./pages/inspections/components/InspectionsWizard/InspectionWizard.jsx";
import InspectionsDeviceList from "./pages/inspections/components/DevicesList/InspectionDeviceList.jsx";
import DOBViolationTracking from "./pages/inspections/components/DOBViolationTracking/DOBViolationTrackingPage.jsx";
import AccountPricing from "./pages/inspections/components/AccountPricingList/AcountPricingListPage.jsx";
import DefaultDeficiences from "./pages/inspections/components/DefaultDeficiencies/DefaultDeficiencies.jsx";
import Email from "./pages/inspections/components/InspectionEmailNotificaiton/InspectionEmailerPage.jsx";
import CreateElv3 from "./pages/inspections/components/DOBNowConnect/ELV3Forms/CreateElv3.jsx";
import TestsDueList from "./pages/inspections/components/TestsDueList/TestDuePage.jsx";
import InspectionsMapView from "./pages/inspections/components/InspectionList/inspectionsMapView.jsx";
import NotificationLetterList from "./pages/approver/notificationletters/index.jsx";

/* --------------------------------------------------------------------------
   INVOICING MODULE
-------------------------------------------------------------------------- */
import InvoiceEntryPage from "./pages/invoicing/components/Invoice Entry/InvoiceEntryPage.jsx";
import InvoiceWizard from "./pages/invoicing/components/Invoice Wizard/InvoiceWizardPage.jsx";
import InvoiceList from "./pages/invoicing/components/Invoice List/InvoiceListPage.jsx";
import InvoiceFinanceCharges from "./pages/invoicing/components/Invoice Finance/InvoiceFinanceChargesPage.jsx";

/* --------------------------------------------------------------------------
   PROPOSALS & JOBS
-------------------------------------------------------------------------- */
import ProposalList from "./pages/proposals/components/Proposals/ProposalsListPage.jsx";

/* --------------------------------------------------------------------------
   REPORTS
-------------------------------------------------------------------------- */
import RouteMapper from "./pages/reports/components/RouteMapper/RouteMapperPage.jsx";
import Chatbot from "./pages/dashboard/ChatBot/Chatbot.jsx";
import ProtectedRoute from "./components/ProtectedRoute.jsx";
import CustomerDashboard from "./pages/customer-dashboard/CustomerDashboard.jsx";



const Content = () => {
  // Get auth state directly from the context
  const { isAuthenticated } = useAuth();


  const publicRoutes = [
    // AUTH / LOGIN
    { path: "/login", element: LoginPage },
    { path: "/forgot-password", element: ForgotPassword },
    { path: "/reset-password", element: ResetPassword },
  ];

  const approverRoutes = [
    { path: "/proposals/approval-page", element: ProposalsApprovalPage },
    { path: "/customer", element: CustomerDashboard },
    { path: "/inspections-violations/notification-letters", element: NotificationLetterList },

  ]


  const routes = [
    // DASHBOARD & MISC
    { path: "/dashboard", element: DashboardRedesign },
    { path: "/user-security", element: UserSecurity },
    { path: "/notifications", element: NotificationList },

    // CALL CENTER
    { path: "/call-center/dispatch-entry", element: DispatchEntry },
    { path: "/call-center/troublecallentry", element: TroubleCallEntry, },
    { path: "/call-center/timeticket-entry-and-edit", element: TimeTicketEntryAndEdit, },
    { path: "/call-center/edit-timeticketentry/:id/:recordData?", element: TimeTicketForm },
    { path: "/call-center/edit-troublecallentry/:id", element: EditTroubleCallForm },
    { path: "/call-center/callcenterlist", element: CallCenterList },
    { path: "/call-center/edit-callcenterlist/:id", element: EditCallCenterForm },
    { path: "/call-center/history", element: History },
    { path: "/call-center/edit-history/:callNumber", element: HistoryEdit },
    { path: "/call-center/employeelog", element: EmployeeLog },
    { path: "/call-center/action-items", element: ActionItemsEntry },
    { path: "/call-center/survey-request-entry", element: SurveyRequestEntry },
    { path: "/call-center/dispatch-hours", element: DispatchHours },
    { path: "/call-center/AdvancedCallCenterDashboard", element: AdvancedCallCenterDashboard },

    // SETUP
    { path: "/setup/add-device", element: AddDevice },
    { path: "/setup/proposal-wizard", element: ProposalWizard },
    // { path: '/setup/add-maintenance-contract-wizard', element: AddMaintenanceContractWizard },
    { path: "/setup/employeelist", element: EmployeeList },
    { path: "/setup/buildinglist", element: BuildingList },
    { path: "/setup/buildings", element: Building },
    { path: "/setup/view-buildings/:id", element: ViewBuilding },
    { path: "/setup/building-form", element: BuildingForm },
    { path: "/setup/view-building-ledger/:id", element: ViewBuildingLedger },
    {
      path: "/setup/account-collections/:buildingId",
      element: AccountCollections,
    },
    { path: "/setup/buildingrecords", element: BuildingRecords },
    { path: "/setup/customers", element: Customer },
    {
      path: "/setup/managementcompanies",
      element: ManagementCompanies,
    },
    { path: "/setup/employees", element: Employee },
    {
      path: "/setup/device-type-editing/:buildingId",
      element: BuildingDeviceEditing,
    },
    { path: "/setup/dataonboarding", element: Dataonboarding },
    { path: "/setup/inspectorslist", element: Inspectors },
    { path: "/setup/rolodex", element: Rolodex },
    { path: "/setup/devicelist", element: DevicePage },
    { path: "/setup/deviceentry", element: DeviceEntry },
    { path: "/setup/salesperson", element: SalesPerson },
    { path: "/setup/paymentterms", element: PaymentTerms },
    { path: "/setup/taxdetails", element: TaxDetails },
    { path: "/setup/company-defaults", element: CompanyDefaultsPage },

    // SINGLE DEVICE
    { path: "/view-device/:id", element: DeviceView },

    // MAINTENANCE
    {
      path: "/maintenance/maintenanceContractsList",
      element: MaintenanceContractsList,
    },
    {
      path: "/maintenance/maintenance-dashboard",
      element: MaintenanceDashboard,
    },
    {
      path: "/maintenance/maintenance-contract-entry",
      element: AddMaintenanceContractWizard,
    },
    {
      path: "/maintenance/schedule-maintenance",
      element: MaintenanceScheduled,
    },
    {
      path: "/maintenance/parent-contract-setup",
      element: ParentContractSetup,
    },
    {
      path: "/maintenance/invoicing-email-setup",
      element: InvoicingEmailSetup,
    },
    {
      path: "/maintenance/maintenance-route-planning",
      element: MaintenanceRoutePlanning,
    },
    { path: "/maintenance/routesummary", element: RouteSummary },
    { path: "/maintenance/routeanalysis", element: RouteAnalysis },

    // INSPECTIONS & VIOLATIONS
    {
      path: "/inspections-violations/violations-lists",
      element: ViolationsList,
    },
    { path: "/inspections-violations/agency", element: Agency },
    {
      path: "/inspections-violations/inspections-devices-list",
      element: InspectionsDeviceList,
    },
    {
      path: "/inspections-violations/inspections-email-notifications",
      element: Email,
    },
    { path: "/inspections-violations/dobnowconnect", element: DOBNowConnect },
    {
      path: "/inspectionsviolations/dobviolationtracking",
      element: ViolationTracking,
    },
    {
      path: "/inspections-violations/violations-entry",
      element: ViolationsEntry,
    },
    { path: "/inspections-violations/device-tests", element: DeviceTests },
    {
      path: "/inspections-violations/service-companies",
      element: ServiceCompanies,
    },
    {
      path: "/inspections-violations/inspections-entry",
      element: InspectionsEntry,
    },
    {
      path: "/inspections-violations/inspections-list",
      element: InspectionsList,
    },
    {
      path: "/inspections-violations/inspections-list-map-view",
      element: InspectionsMapView,
    },
    {
      path: "/inspections-violations/inspections-wizard",
      element: InspectionsWizard,
    },
    {
      path: "/inspections-violations/dob-violation-tracking",
      element: DOBViolationTracking,
    },
    {
      path: "/inspections-violations/default-deficiencies",
      element: DefaultDeficiences,
    },
    {
      path: "/inspections-violations/account-pricing",
      element: AccountPricing,
    },
    {
      path: "/inspections-violations/device-defects/:deviceID",
      element: DeviceDataDefects,
    },
    {
      path: "/inspections-violations/group-number-devices/:groupNumber",
      element: GroupNumberDevices,
    },
    { path: "/inspections-violations/create-elv3", element: CreateElv3 },
    { path: "/inspections-violations/tests-due", element: TestsDueList },

    // INVOICING
    { path: "/invoicing/invoice-entry-page", element: InvoiceEntryPage },
    { path: "/invoicing/invoice-wizard", element: InvoiceWizard },
    { path: "/invoicing/invoice-list", element: InvoiceList },
    {
      path: "/invoicing/invoice-finance-charges",
      element: InvoiceFinanceCharges,
    },

    // PROPOSALS & JOBS
    // { path: "/proposals-and-jobs/proposals-and-jobs-list", element: ProposalsAndJobsList },
    {
      path: "/proposals-and-jobs/proposals-and-jobs-list",
      element: ProposalList,
    },
    { path: "/proposals-and-jobs/proposal-wizard", element: ProposalWizard },

    // REPORTS
    { path: "/reports/route-mapper", element: RouteMapper },

    // Catch-all / default
  ];


  return (
    // Render Navbar only if authenticated
    // Pass non-auth related props if needed (e.g., UI state)
    // Navbar must be refactored to use useAuth() for user info and logout action
    // Conditionally render Chatbot based on authentication 
    <div>
      {isAuthenticated && (
        <>
          <Navbar />
          <Chatbot />
        </>
      )}


      <Routes>
        {/* Public Routes */}
        {publicRoutes.map((route, index) => (
          <Route
            key={`public-${index}`}
            path={route.path}
            // Removed props being passed here, element uses useAuth if needed
            element={<route.element />}
          />
        ))}

        {/* General Authenticated Routes */}
        {routes.map((route, index) => (
          <Route
            key={`auth-${index}`}
            path={route.path}
            element={
              // ProtectedRoute now uses useAuth() internally to check isAuthenticated and roles
              <ProtectedRoute roles={["POWER_USER", "ADMIN", "MANAGER", "DISPATCHER"]}>
                <route.element /* Removed props={...} */ />
              </ProtectedRoute>
            }
          />
        ))}

        {/* Approver Specific Routes */}
        {approverRoutes.map((route, index) => (
          <Route
            key={`approver-${index}`}
            path={route.path}
            element={
              // ProtectedRoute now uses useAuth() internally
              <ProtectedRoute roles={["APPROVER"]}>
                <route.element /* Removed props={...} */ />
              </ProtectedRoute>
            }
          />
        ))}

        {/* Specific Profile Route */}
        <Route
          path={"/user/profile"}
          element={
            // ProtectedRoute now uses useAuth() internally
            <ProtectedRoute roles={["APPROVER", "POWER_USER", "ADMIN", "MANAGER", "DISPATCHER"]}>
              {/* Profile component must use useAuth() to get user info */}
              <Profile />
            </ProtectedRoute>
          }
        />

        {/* Redirect root path based on authentication */}
        <Route
          path="/"
          element={isAuthenticated ? <Navigate to="/dashboard" /> : <Navigate to="/login" />}
        />
        {/* Redirect logout path to login */}
        <Route path="/logout" element={<Navigate to="/login" />} />

        {/* Add a catch-all for undefined routes if desired */}
        {/* <Route path="*" element={<NotFoundPage />} /> */}

      </Routes>
    </div>
  );
};



// --------------------------------------------------------------------------
// FINAL APP COMPONENT (using AuthContext)
// --------------------------------------------------------------------------
function App() {
  // --- State from AuthContext ---
  // isLoading: True while context checks initial auth state (e.g., refresh token)
  // isAuthenticated: True if user is considered logged in
  // logout: Function provided by context to handle logout process
  const { isAuthenticated, logout, isLoading: isAuthLoading } = useAuth();

  // --- Local State ONLY for the Idle Warning UI ---
  const [showWarningModal, setShowWarningModal] = useState(false);
  const [warningTimer, setWarningTimer] = useState(60); // Warning duration in seconds

  // --- Idle Timer Configuration ---
  const IDLE_TIMEOUT_MS = 10 * 60 * 1000;     // e.g., 10 minutes to idle
  const WARNING_DURATION_SEC = 60;           // e.g., 60 seconds warning countdown

  // --- Idle Timer Callbacks ---
  const onIdle = useCallback(() => {
    // Trigger the warning modal ONLY if the user is actually logged in
    if (isAuthenticated) {
      setWarningTimer(WARNING_DURATION_SEC); // Reset countdown value
      setShowWarningModal(true);             // Show the modal
    }
  }, [isAuthenticated]); // Dependency: only needs to update if auth status changes

  // const onActive = useCallback(() => {
  //   // Hide warning modal if user becomes active again (e.g., moves mouse)
  //   // This callback runs on any detected activity
  //   if (showWarningModal) {
  //     setShowWarningModal(false);
  //   }
  // }, [showWarningModal]); // Dependency: only needs to update if modal visibility changes

  // Initialize the Idle Timer hook
  const { reset } = useIdleTimer({
    onIdle,             // Function to call when user becomes idle
    // onActive,           // Function to call when user becomes active
    timeout: IDLE_TIMEOUT_MS, // Idle time duration
    throttle: 500,          // Check activity frequency
    crossTab: true,       // Enable cross-tab detection
    syncTimers: 1000,    // Sync timers across tabs every second
  });

  // --- Warning Modal Countdown Timer ---
  useEffect(() => {
    let interval = null;
    // Only run the countdown if the modal is visible AND user is authenticated
    if (showWarningModal && isAuthenticated) {
      interval = setInterval(() => {
        setWarningTimer((prevTimer) => {
          if (prevTimer <= 1) {
            clearInterval(interval);        // Stop the interval
            setShowWarningModal(false);     // Hide the modal
            logout();                       // <<< Call context logout action
            return 0;
          }
          return prevTimer - 1; // Decrement the timer
        });
      }, 1000); // Run every second
    }

    // Cleanup function: clear interval if modal is hidden or component unmounts
    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [showWarningModal, isAuthenticated, logout]); // Dependencies for the effect

  // --- Modal Button Handlers ---
  const handleContinueSession = () => {
    setShowWarningModal(false); // Hide the modal
    reset();                    // Reset the idle timer (marks user active)
  };

  // --- Render Logic ---

  // Show loading indicator while AuthContext initializes (e.g., checks refresh token)
  if (isAuthLoading) {
    return (
      <div className="gradient-bg h-screen flex items-center justify-center">
        <CircularProgress size={100} style={{ color: "white" }} />
      </div>
    );
  }

  // Render the main application structure
  return (
    <Router>
      <ScrollToTop />
      {/* Render the Content component which contains the Routes */}
      {/* Pass NO auth props; Content must use useAuth() */}
      <Content />

      {/* Render the Idle Warning Modal conditionally */}
      {isAuthenticated && showWarningModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
          {/* Your existing modal JSX structure */}
          <div className="bg-white lg:h-1/3 lg:w-1/4 md:h-1/3 md:w-1/4 sm:h-1/4 sm:w-1/6 border rounded-2xl px-6 flex flex-col text-center justify-between shadow-lg overflow-y-auto">
            <h1 className="text-lg mt-6">Your session will expire due to inactivity in:</h1>
            <div className="flex flex-row justify-center">
              <p className="text-3xl">{warningTimer}</p>
              <p className="text-lg text-bottom px-2 pt-2">seconds</p>
            </div>
            <p className="text-sm text-gray-600">
              Click 'Continue' to stay logged in.
              {/* Press a key or move the mouse to stay logged in. */}
            </p>
            <div className="pb-4">
              <button
                className="w-1/4 py-2 mx-4 bg-blue-500 text-white font-semibold rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400"
                onClick={handleContinueSession} // Calls the local handler
              >
                Continue
              </button>
              <button
                className="w-1/4 py-2 mx-4 bg-red-500 text-white font-semibold rounded-md hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-400"
                onClick={logout} // <<< Calls logout directly from AuthContext
              >
                Logout
              </button>
            </div>
          </div>
        </div>
      )}
    </Router>
  );
}


export default App;
